import Icon from 'veui/components/Icon'
import { IconScan } from 'dls-icons-vue'

Icon.register('scan', IconScan)
